export default __webpack_public_path__ + "static/media/Photoshop.68517700.png";